import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <div id="footer">
                <div className="inner">
                    <ul className="copyright">
                        <li>&copy; Gatsby Starter Strata</li><li>Design: <a href="http://html5up.net">HTML5 UP</a></li>
                    </ul>
                </div>
                <div style={{position: 'absolute', bottom: '5px'}}>
                    Taken (by me!) in beautiful Santa Barbara, CA
                </div>
            </div>
        )
    }
}

export default Footer
